import Button from "../../../../../Components/Button/Button";
import Page from "../../../../../Components/Page/Page";
import css from "./EditTemplate.module.css";
import MilestoneEdit from "../../../../../Components/Milestone2/MilestoneEdit";
import { useState, useEffect } from "react";
import DragDrop from "../../../../../Components/DragDrop/DragDrop";
import Svg from "../../../../../Components/Svg/Svg";
import SvgOptions from "../../../../../Components/Svg/SvgOptions";
import EditTemplateOptions from "./EditTemplateOptions";
import Form from "../../../../../Components/Form/Form";
import { Get, Post } from "../../../../../Services/Server";
import Url from "../../../../../Services/Url";
import MilestoneSelect from "../../../../../Modals/MilestoneSelect/MilestoneSelect";
import { useParams } from "react-router-dom";
import Utils from "../../../../../Services/Utills";
import User from "../../../../../Services/User";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";

let lst = [];

const Left = ({ children, onChange }) => {
	const id = children ? children.id : null;
	const [showCompanyField, setShowCompanyField] = useState(false);
	const [fmoptions, setOptions] = useState();

	useEffect(() => {
		// Initialize fmoptions with data from 'children'
		const opts = EditTemplateOptions(showCompanyField);
		if (children) {
			const { name, type, use_case, entCompanyId } = children; // Note: using entCompanyId here

			// Map initial values to form fields
			opts.Fields[0][0].value = name;
			opts.Fields[0][1].value = type;
			opts.Fields[1][0].value = use_case;

			// Set initial value for company field if it's visible
			if (showCompanyField && entCompanyId) {
				const companyField = opts.Fields.find((row) =>
					row.find((f) => f.name === "entCompanyId")
				)?.[0];
				if (companyField) {
					// Assuming entCompanyId in 'children' is the full object {id, name, ...}
					companyField.value = entCompanyId;
				}
			}
		}
		setOptions(opts);
	}, [children, showCompanyField]);

	// *** NEW HANDLER TO UPDATE FORM STATE ON CHANGE ***
	const handleFormChange = (newVal, name) => {
		if (!fmoptions) return;

		// Utility to deeply find and update a field's value in the fmoptions structure
		const updateField = (options) => {
			const newOpts = { ...options, Fields: [...options.Fields] };
			for (let i = 0; i < newOpts.Fields.length; i++) {
				const row = newOpts.Fields[i];
				const fieldIndex = row.findIndex((f) => f.name === name);
				if (fieldIndex !== -1) {
					const newRow = [...row];
					newRow[fieldIndex] = { ...newRow[fieldIndex], value: newVal };
					newOpts.Fields[i] = newRow;
					return newOpts;
				}
			}
			return newOpts;
		};

		setOptions((prevOpts) => updateField(prevOpts));
	};

	const handleToggle = (checked) => {
		setShowCompanyField(checked);

		// Re-initialize options to include or exclude the company field,
		// while preserving existing data.
		const opts = EditTemplateOptions(checked);
		if (fmoptions) {
			// Copy name, type, use_case from current state to new options
			opts.Fields[0][0].value = fmoptions.Fields[0][0].value;
			opts.Fields[0][1].value = fmoptions.Fields[0][1].value;
			opts.Fields[1][0].value = fmoptions.Fields[1][0].value;

			// If company field was present, copy its value too (if it will be visible again)
			const currentCompanyFieldRow = fmoptions.Fields.find((row) =>
				row.find((f) => f.name === "entCompanyId")
			);
			if (checked && currentCompanyFieldRow) {
				const currentCompanyField = currentCompanyFieldRow[0];
				const newCompanyField = opts.Fields.find((row) =>
					row.find((f) => f.name === "entCompanyId")
				)?.[0];
				if (newCompanyField && currentCompanyField.value) {
					newCompanyField.value = currentCompanyField.value;
				}
			}
		}
		setOptions(opts);
	};

	const handleSave = () => {
		const formData = Utils.FormObject(fmoptions);

		// Include company id only if toggle is ON
		const payload = {
			...formData,
			id,
			// Access the 'id' property of the entCompanyId object only if the field is shown
			entCompanyId: showCompanyField ? formData.entCompanyId?.id : null,
		};

		onChange(payload);
	};

	return (
		<div className={css.LCont}>
			{fmoptions && (
				<>
					{/* *** ADDED onChange PROP TO FORM *** */}
					<Form onChange={handleFormChange}>{fmoptions}</Form>

					{/* --- TOGGLE SECTION --- */}
					<div className={css.ToggleRow}>
						<span className={css.ToggleText}> Add Milestone Company</span>

						<div className={css.ToggleContainer}>
							<label className={css.Switch}>
								<input
									type="checkbox"
									checked={showCompanyField}
									// *** UPDATED ONCHANGE TO NEW HANDLER ***
									onChange={(e) => handleToggle(e.target.checked)}
								/>
								<span className={css.Slider}></span>
							</label>
							<div className={css.InfoIcon}>
								<div className={css.InfoCircle}>i</div>
								<span className={css.TooltipText}>
									When enabled, this milestone template is created for a
									specific company. Only that company will be able to use it.
								</span>
							</div>
						</div>
					</div>
				</>
			)}
			<div className={css.Bottom}>
				<div>
					<div>
						<Button className="Btn-Mid Inverse">Cancel</Button>
					</div>
					<div>
						<Button onClick={handleSave} className="Btn-Mid Active">
							Save
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

const Right = ({ children, ModalAction, onChange }) => {
	const { openPopup } = ModalAction;
	const [unassigned, setUnassigned] = useState([]);
	const [list, setList] = useState([]);

	useEffect(() => {
		Get(Url.enterprise.milestones).then((resp) => {
			//console.log(resp);
			//console.log(children.milestones)
			console.log(children);
			if (children) {
				setList(children.milestones);
				setUnassigned(
					resp.filter(
						(r) => !children.milestones.find((m) => m.name === r.name)
					)
				);
			} else {
				setUnassigned(resp);
			}
		});
	}, []);

	useEffect(() => {
		onChange(list);
		lst = [...list];
		setUnassigned(
			[...unassigned, ...list].filter((un) => !list.find((l) => l.id === un.id))
		);
	}, [list]);

	const onDelete = (ms) => {
		setList(lst.filter((fl) => fl.id !== ms.id));
		setUnassigned([...unassigned, ms]);
	};

	const addMilestone = () => {
		const Options = {
			element: MilestoneSelect,
			milestones: unassigned,
			handleAdd: handleAdd,
			handleContinue: ModalAction.closePopup,
		};
		openPopup(Options);
	};

	const handleAdd = (ms) => {
		lst.push({ ...ms });
		setList([...lst]);
	};

	return (
		<div>
			<div className={css.RHead}>
				<h2> {list.length} Milestones</h2>
			</div>
			<div className={css.RMSList}>
				<div>Milestone name</div>
				<div>Assignee</div>
				<div>Client</div>
			</div>
			<DragDrop
				Events={{ onDelete: onDelete }}
				Element={MilestoneEdit}
				onOrderChanged={setList}
			>
				{list}
			</DragDrop>
			<div onClick={addMilestone} className={css.addMilestoneBtn}>
				<div>
					<Svg className={css.svg}>{SvgOptions.Add}</Svg>
				</div>
				<div>Add Milestone</div>
			</div>
		</div>
	);
};

const EditTemplate = ({ ModalAction }) => {
	const param = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const state = location.state;
	const title = param["*"] + " Template";
	const [list, setList] = useState([]);

	const msChanged = (lst) => {
		setList(lst);
	};

	const tmChange = (dt) => {
		const rec = {
			...dt,
			milestones: list.reduce((a, v) => {
				delete v.id;
				return [...a, v];
			}, []),
			owner: { id: User.getBiodata().id },
		};
		Post(Url.enterprise.milestoneTemplate, rec)
			.then((resp) => {
				toast("Template Saved");
				navigate("../");
			})
			.catch((err) => {
				toast("Operation failed");
			});
	};

	return (
		<Page
			LTitle={title}
			left={<Left onChange={tmChange}>{state}</Left>}
			right={
				<Right onChange={msChanged} ModalAction={ModalAction}>
					{state}
				</Right>
			}
		></Page>
	);
};

export default EditTemplate;
